
// 基础模块
import basic from './modules/basic'
import home from './modules/home'
import story from './modules/story'
import course from './modules/course'
import news from './modules/news'
import building from './modules/building'
import model from './modules/model'
const routes = [
  ...basic,
  ...home,
  ...story,
  ...course,
  ...news,
  ...building,
  ...model
]

export default routes
